<template>
    <div>
        <Title>基本信息</Title>
        <div class="panel">
            <div class="label">项目名称</div>
            <div class="value3">{{ extra.prjName }}</div>

            <div class="label">项目编号</div>
            <div class="value1">{{ extra.prjNo }}</div>
            <div class="label">设计编号</div>
            <div class="value2">{{ extra.designNo }}</div>

            <div class="label">客户名称</div>
            <div class="value3">{{ extra.customerName }}</div>

            <div class="label">项目类型</div>
            <div class="value1">
                <DataDictFinder dictType="cosys.projectType" :dictValue="extra.prjType" />
            </div>
            <div class="label">项目类别</div>
            <div class="value2">
                <DataDictFinder dictType="cosys.prjCategory" :dictValue="extra.prjCategory" />
            </div>

            <div class="label">管理级别</div>
            <div class="value1">
                <DataDictFinder dictType="cosys.manageLevel" :dictValue="extra.manageLevel" />
            </div>
            <div class="label">服务等级</div>
            <div class="value2">
                <DataDictFinder dictType="cosys.serviceLevel" :dictValue="extra.serviceLevel" />
            </div>

            <!--            <div class="label">联系电话</div>-->
            <!--            <div class="value1">{{ extra.phone }}</div>-->
            <!--            <div class="label">单位地址</div>-->
            <!--            <div class="value2">{{ extra.unitAddress }}</div>-->

            <div class="label">接收部门</div>
            <div class="value1">{{ extra.respDeptName }}</div>
            <div class="label">配合部门</div>
            <div class="value2">{{ extra.cooperateDeptNames }}</div>

        </div>
        <Title>其他信息</Title>
        <div class="panel">
            <div class="label">设计任务内容及要求</div>
            <div class="value3">{{ extra.designContent }}</div>
            <div class="label">转交基础资料</div>
            <div class="value3">{{ extra.basicMaterials }}</div>

            <div class="label">备注</div>
            <div class="value3">{{ extra.remark }}</div>

            <div class="label">附件</div>
            <div class="value3">
                <div v-for="(item, index) in attachmentList" :key="index">
                    <a :href="item.url" target="_blank" @click.prevent="handleFileClick($event, item.url, item.name)">{{ item.name }}</a>
                </div>
            </div>


        </div>
        <Title>阶段信息</Title>
        <div>
            <a-table
                :columns="phaseColumns"
                :data-source="extra.phases || []"
                row-key="index"
                :pagination="false"
                bordered
            />
        </div>
        <Padding />
    </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "../Title";

export default {
    components: {
        Title,
    },
    computed: {
        ...mapState("approval", ["detail"]),
        extra() {
            return this.detail.extra ? this.detail.extra : {};
        },
        attachmentList() {
            // 同时检查 detail 和 extra 中的 attachment 和 attachmentPaths
            const attachment = this.detail.attachment || this.extra.attachment;

            if (!attachment) return [];

            let urls = [];
            if (attachment) {
                urls = String(attachment)
                    .split(',')
                    .filter(Boolean)
                    .map(url => url.trim().replace(/`/g, '').trim());
            }

            console.log("urls:::", urls);

            return urls.map(url => {
                // 从URL中提取文件名
                let name = '';
                try {
                    const urlObj = new URL(url);
                    const pathname = urlObj.pathname;
                    const filename = pathname.substring(pathname.lastIndexOf('/') + 1);
                    name = decodeURIComponent(filename);
                } catch (e) {
                    // 如果URL解析失败，尝试从字符串中提取
                    const match = url.match(/\/([^/?]+)(?:\?|$)/);
                    name = match ? decodeURIComponent(match[1]) : url;
                }
                return { url, name };
            });
        },
        // 阶段表格列配置
        phaseColumns() {
            return [
                {
                    title: "阶段名称",
                    key: "phaseName",
                    width: 160,
                    customRender: (_, record) => `${record.phaseName || '-'}（${record.phaseCode || '-'}）`,
                },
                {
                    title: "主办部门",
                    dataIndex: "mainDeptName",
                    key: "mainDeptName",
                    width: 140,
                },
                {
                    title: "配合部门",
                    dataIndex: "cooperateDeptNames",
                    key: "cooperateDeptNames",
                    width: 140,
                },
                {
                    title: "计划项目负责人",
                    dataIndex: "planPrjLeaderName",
                    key: "planPrjLeaderName",
                    width: 150,
                },
                {
                    title: "下达日期",
                    dataIndex: "issueDate",
                    key: "issueDate",
                    width: 140,
                    customRender: (text) => text ? new Date(text).toLocaleDateString() : '-',
                },
                {
                    title: "要求完成日期",
                    dataIndex: "requireFinishDate",
                    key: "requireFinishDate",
                    width: 140,
                    customRender: (text) => text ? new Date(text).toLocaleDateString() : '-',
                },
            ];
        },
    },
    methods: {
        isPdfFile(filename) {
            return filename && filename.toLowerCase().endsWith('.pdf');
        },
        previewPdf(url, filename) {
            const routeUrl = this.$router.resolve({
                path: '/pdf-preview',
                query: { url, title: filename || 'PDF预览' }
            }).href;
            window.open(routeUrl, '_blank');
        },
        deepDecodeURIComponent(str) {
            // 仅当结果中仍含 %25（编码的百分号）时才继续解码：
            // %25 是"还有一层编码未解"的唯一信号；没有 %25 时再解码会破坏
            // URL 中合法的编码字符（如文件名的 %2B、OSS 签名参数的 %2F），导致下载/查看链接失效
            let decoded = str;
            while (decoded.includes('%25')) {
                const prev = decoded;
                try {
                    decoded = decodeURIComponent(decoded);
                } catch (e) {
                    break;
                }
                if (decoded === prev) break;
            }
            return decoded;
        },
        handleFileClick(event, url, filename) {
            event.preventDefault();
            const decodedUrl = this.deepDecodeURIComponent(url);
            if (this.isPdfFile(filename)) {
                this.previewPdf(decodedUrl, filename);
            } else {
                const a = document.createElement('a');
                a.href = decodedUrl;
                a.download = filename || '';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        },
    },
};
</script>

<style lang="less" scoped>
.panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;

    & > div {
        padding: 8px;
        border-bottom: 1px solid #e8e8e8;
    }

    .label {
        background-color: #fafafa;
        border-right: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
    }

    .value1 {
        grid-column-start: 2;
        grid-column-end: 4;
    }

    .value2 {
        grid-column-start: 5;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value3 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }
}
.ant-table-thead tr{
    background: #d0d0d0;
}
</style>